import {MaskedNumberOptions} from 'imask/masked/number';

interface Params {
    allowDecimal: boolean;
    allowNegatives: boolean;
    isNegativeRequired: boolean;
    thousandsSeparatorSymbol: string;
    customMaskOptions: Partial<MaskedNumberOptions>
}

export const defaultMaskedNumberParams: Params = {
    customMaskOptions: {},
    allowDecimal: true,
    allowNegatives: false,
    isNegativeRequired: false,
    thousandsSeparatorSymbol: '.',
}

export const getMaskedNumberOptions = (paramsPartial: Partial<Params>) => {
    // https://github.com/uNmAnNeR/imaskjs/tree/master/packages/angular-imask
    // https://imask.js.org/guide.html

    const params = {
        ...defaultMaskedNumberParams,
        ...paramsPartial
    };

    const options: MaskedNumberOptions = {
        mask: Number,
        radix: ',',
        thousandsSeparator: params.thousandsSeparatorSymbol,
        padFractionalZeros: true,
        scale: params.allowDecimal ? 2 : 0,
        ...params.customMaskOptions,
    };

    if (params.isNegativeRequired) {
        options.max = 0;
    }

    /* https://stackoverflow.com/questions/76585224/imask-plugin-for-angular-the-unmask-property-doesnt-allow-typed
     * Lösung: die format()-Methode wird anders definiert. In der Original-Implementierung kommt es zu einer seltsamen Format-Exception.
     * Es gibt keinen Weg, diese Neudeklaration der Methode in einem Unit-Test zu testen. */
    options.format = (value: any) => {
        return value === '' ? null : value + '';
    }

    return options;

}
